import { LiliMask } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT_HINT } from '@Consts/constants';
import { OnboardingFormFields } from '@Types/index';
import { ControlledMaskedInput } from './ControlledInputs';

interface DateOfBirthInputProps {
  readonly?: boolean;
  tabIndex?: number;
}

export const DateOfBirthInput = ({ readonly, tabIndex }: DateOfBirthInputProps) => {
  const { t } = useTranslation();

  return (
    <ControlledMaskedInput
      tabindex={tabIndex}
      name={OnboardingFormFields.DATE_OF_BIRTH}
      title={`${t('pages.identity.bdFieldTitle')} (${DATE_FORMAT_HINT})`}
      id={OnboardingFormFields.DATE_OF_BIRTH}
      mask={LiliMask.DATE}
      readonly={readonly}
      hint={DATE_FORMAT_HINT}
      isPublic={false}
    />
  );
};
